/** Angular */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
/** Services */
import { BydHttpMockInterceptorService } from './services/byd-http-mock-interceptor.service';
import { BydHttpMockService } from './services/byd-http-mock.service';
/** Interfaces */
import { BydHttpMockInterface } from './interfaces/byd-http-mock.interface';
/** Injections */
import { BYD_HTTP_MOCK_INJECTION_TOKEN } from './injections/byd-http-mock-injection.token';

@NgModule()
export class BydHttpMockModule {
  /**
   * Use this method in the root module to mock http requests by sending an array of `BydHttpMockInterface`.
   *
   * @param httpMockData the http mock data
   * @returns ModuleWithProviders
   * @example BydHttpMockModule.forRoot(
   *            [
   *                   {
   *                       url: environment.API_URL/projects,
   *                       body: [{id:1},{id:2}],
   *                   },
   *                  {
   *                       url: environment.API_URL/v1/projects,
   *                       body: [{id:1},{id:2}],
   *                   }
   *            ],
   *          ),
   */
  static forRoot(httpMockData: BydHttpMockInterface[]): ModuleWithProviders<BydHttpMockModule> {
    return {
      ngModule: BydHttpMockModule,
      providers: [
        BydHttpMockService,
        {
          provide: BYD_HTTP_MOCK_INJECTION_TOKEN,
          useValue: httpMockData,
        },
        BydHttpMockInterceptorService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BydHttpMockInterceptorService,
          multi: true,
        },
      ],
    };
  }
}
